import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType, Dataset } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi, ApiService } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-global-supplier-type-field-config',
  standalone: false,
  templateUrl: './global-supplier-type-field-config.component.html'
})
export class GlobalSupplierTypeFieldConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor() { }

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-supplier-type-field-configuration',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'globalSupplierId', header: 'Global Supplier', type: ColumnType.MultiSelectComplex, setUrl: 'global-supplier/lookup', isReadonly: true, isPrimary: true  },
        { field: 'documentTypeCode', header: 'Document Type', type: ColumnType.DropDown, setUrl: 'document-type/lookup' },
        { field: 'fieldId', header: 'Field', type: ColumnType.DropDown, setUrl: 'ocr-field/lookup' },
        { field: 'searchRegex', header: 'Search Regex', type: ColumnType.String },
        { field: 'captureRegex', header: 'Capture Regex', type: ColumnType.String },
        { field: 'replaceRegex', header: 'Replace Regex', type: ColumnType.String },
        { field: 'validateRegex', header: 'ValidateRegex', type: ColumnType.String }
      ],
      addFormConfig: {
        header: 'Add Global Supplier Type Field'
      },
      isConfigurable: true
    };
  }
}

class DocumentType {
  documentTypeCode: string;
  documentTypeName: string;
}
